<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col sm="12">
                <b-card header-tag="header" footer-tag="footer">
                    <div slot="header">
                        <strong> Zone Management</strong> 
                        <div class="card-header-actions">
                            <b-button size="sm" class="btn btn-sm btn-primary mr-4 " data-toggle="tooltip"  variant='primary' @click="addZone()">Add Zone</b-button>
                        </div>
                    </div>

                    <div>
                        <b-collapse id="Zone">
                            <b-card>
                                <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
                                    <b-col md="12">
                                        <b-row>
                                            <b-col sm="6">
                                                <b-form-group
                                                label=" Add Zone"
                                            :label-cols="3">   
                                                <!-- <label for="hubtitle">Hub Title</label> -->
                                                <b-form-input class="input" type="text" v-model="Customer.zone" name="Zone"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.Zone') }" placeholder="Enter Zone">             
                                            </b-form-input>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                    <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.Zone')" >{{ errors.first('form-1.Zone') }}</i>
                                                    
                                                </span>
                                            </b-input-group>
                                            </b-form-group>
                                            </b-col> 
                                        </b-row>

                                        <b-row>
                                            <b-col sm="6">
                                                <b-form-group label="Selected Pincodes"
                                                    :label-cols="3">   
                                                <ejs-multiselect id='multiselect' placeholder="Select Pincodes" name="getPincodes" v-model="getPincodes"   :dataSource='optionsPincodes'     :fields='getPincodesFields'  v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('form-2.getPincodes') }">
                                                </ejs-multiselect>
                                                <span v-show="errors.has('form-2.getPincodes')" class="help text-danger">{{ errors.first('form-2.getPincodes') }}</span>
                                                </b-form-group> 
                                            </b-col>  
                            
                                        </b-row>
                                    </b-col>
                                
                                <footer class="column has-text-right">
                                    <b-button variant="primary" size="md" type="submit" style="float: right;">ADD</b-button>
                                    </footer>
                                </b-form>
                            </b-card>
                        </b-collapse>
                    </div>
                    <b-row>
                        <b-col md="12">
                            <b-table show-empty responsive   :items="zonelist" :busy="isBusy"    :current-page="currentPage"  :fields="fields" :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" > 

                                <div slot="table-busy" class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div> 
                                <template slot="Action" slot-scope="row" >
                                    <!-- <b-button size="sm" id="printbutton"  value="print a div!"  @click="setStickerHTMl(row.item);"  class="mr-1" style="background: #b0c4de !important;color: #000 !important;">
                                        Print Stiker 
                                    </b-button> -->
                                    <!-- [{{row.item.selected }}] -->
                                    <!-- <input @change="setStickerHTMl(row.item)" type="radio" name="radAnswer"  class="shipmentscheckbox" id="stiker" :checked="checkedData" > -->
                                    <input @change="setStickerHTMl($event,row.item)" type="radio" name="radAnswer" v-model="row.item.selected" class="shipmentscheckbox" id="stiker" :checked="checkedData" >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                                    <b-button    id="printbutton" variant="primary" size="sm" value="print a div!" @click="barcodedata('printableArea',row.item)" style="background: #b0c4de !important;color: #000 !important;">Print Zone </b-button>&nbsp;&nbsp;
                                   </template>
                              </b-table>  
                        </b-col>
                    </b-row>
                    <div id="printableArea" >
                        <div class="page-break" v-for="zone in zoneArr">
                         <div style="font-size: 25px;"><b>{{zone.zone_title}}</b></div>
                         <!-- <br> -->
                         <br>
                            <qr-code :text="zone.zone_id"></qr-code>
                        </div>           
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
import QrcodeVue from 'qrcode.vue'
export default {
    data() {
        return {
            Customer : {},
            tags2 : [],
            tags :[],
            zonelist : [],
            fields : [
                { key : 'zone_id', label :'Zone Id', sortable: true},
                { key : 'zone_title', label :'Zone Title', sortable: true},
                { key : 'pincodes', label :'Service Pincode', sortable: true},
                { key : 'Action', label :'Action', sortable: true}
            ],
            isBusy : false,
            pincodeAssigntoAdmin:[],
            getPincodes:[],
            getPincodesFields:{ text: 'name', value: 'id' },
            AdminassignPincode :[],
            optionsPincodes:[],
            qrdetail:[],
            QRcodezone_id :'',
            QRcodezone_title :'',
            checkedData: false,
            zoneArr:[],
            selected_zone_id:'',
            QrcodeVue
            
        }
    },
    components: {
        QrcodeVue,
    },
    created() {
        this.ZoneListings();
       
        
    },
    methods: {
        addZone : function() {
            // alert("ok");
            document.getElementById("Zone").style.display = "block";
            this.pincodeAssign();
        },

        validateForm(scope) {
            this.$validator.validateAll(scope).then(result => {
                if(result){
                this.addZoneForm()
                }
            })
        },

        pincodeAssign(){
            var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)
            this.AdminassignPincode =[];
            const obj = {
                
                sysusermasterid:`${userInfo.sysusermasterid}`,
                usertype:`${userInfo.user_type}`,
            };
            
            
                console.log("pincodes",obj);
                // return false;
            
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getPincodesAgainstAdminOrCoordinator`,obj)
                .then((result) => {
                console.log("Result",result);
                // document.getElementById("overlayModal").style.display = "none";
                if (result.body.returnmsg === 'Successful') {
                    this.pincodeAssigntoAdmin=result.body.returnvalue; 
                    console.log("this.pincodeAssigntoAdmin",this.pincodeAssigntoAdmin)
                    for (let i = 0; i < this.pincodeAssigntoAdmin.length; i++) {
                        const pincodes = {
                            // this.pincodeAssigntoAdmin[i].service_pincode;
                            name:this.pincodeAssigntoAdmin[i].service_pincode ,
                            id: this.pincodeAssigntoAdmin[i].service_pincode.toString(),
                        }
                        console.log("pincodessss",pincodes)
                        this.AdminassignPincode.push(pincodes);
                        // this.getPincodes.push(pincodes.name)
                        console.log("this.AdminassignPincode",this.AdminassignPincode)
                    }
                    this.checkPincodeAssign(this.AdminassignPincode);
                } else {
                    
                    this.pincodeAssigntoAdmin=[];
                    
                }
                })
            .catch((ex) => {
            console.log('error-----', ex)
            })
        },

        checkPincodeAssign(value){
            // console.log("Valureee",value)
            for(let i=0;i<value.length;i++){
            this.optionsPincodes.push(value[i]);
            this.getPincodes.push(value[i].id);
            }
        },

        addZoneForm : function (){
            console.log("tages",this.tags)
            console.log("tags",this.tags2.length)
                // document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            var SelectedPincode =[];
            console.log("gvhjbn",typeof(SelectedPincode));
            for (let i = 0; i < this.tags2.length; i++) {
                const listing = this.tags2[i];
                console.log("DSfd",listing)
                 SelectedPincode.push(listing.text);
                 console.log("gvjhbghjbn",SelectedPincode)
            }
            
            const zoneObj = {
                sysusermasterid:`${userInfo.sysusermasterid}`,
                zone_title:`${this.Customer.zone}`,
                pincodes:this.getPincodes,
                createdby : `${userInfo.userfirstname}` + '' + `${userInfo.userlastname}`,

        };
        console.log("zoneObj",zoneObj);
        // return false;
        if (this.getPincodes.length !=0) {
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/createZoneAndAssignPincodes`,zoneObj)
            .then(result => {
                // alert("Api")
                    // document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === "Successful") {
                    this.$fire({
                    text:"Added Successfully",
                    type: "success",
                    timer: 30000
                    }); 
                    this.ZoneListings();
                    this.Customer = {};
                    this.errors.clear('form-1');
                    document.getElementById("Zone").style.display = "none"; 
                    } else {
                        this.$fire({
                        text:result.body.returnvalue,
                        type: "error",
                        timer: 30000
                    }); 
                    }
                    
                })
                .catch(ex => {
                    console.log("error", ex);
                });
        }else{
            this.$fire({
                        text:"Please Enter Valid PinCode ",
                        type: "error",
                        timer: 30000
                    }); 
        }
            
        },

        ZoneListings :function(){
            this.isBusy=true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            const obj={
                sysusermasterid:`${userInfo.sysusermasterid}`,
                usertype:`${userInfo.user_type}`,

            }
            this.$http
                .post(
                    `${ CONSTANTS.MIGRATION_API_URL}/getZoneAndAssignPincodes`,obj).then(result => {
                    this.isBusy=false;
                    console.log("result",result)
                    if (result.body.returnmsg === "Successful") {
                        // alert("ok")
                    this.zonelist=result.body.returnvalue;
                    console.log("zonelist",this.zonelist);
                    this.totalRows=result.body.returnvalue.length;
                    }else{
                        this.zonelist=[];
                        this.totalRows=0;
                    }
                    }).catch(ex => {
                    console.log("error", ex);
                });
        },
        
        barcodedata(printableArea,value){
            if(this.checkedData == true && this.selected_zone_id == value.zone_id)
            {
                var printContents = document.getElementById("printableArea").innerHTML;
                // alert(printContents)
                var disp_setting="toolbar=yes,location=no,";
                disp_setting+="directories=yes,menubar=yes,";
                disp_setting+="scrollbars=yes,width=650, height=600, left=100, top=25";
                var content_vlue = printContents;
                var docprint=window.open("","",disp_setting);
                docprint.document.open();
                docprint.document.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"');
                docprint.document.write('"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">');
                docprint.document.write('<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">');
                docprint.document.write('<head>');
                docprint.document.write('<style type="text/css">body{ margin:0px;');
                docprint.document.write('font-family:verdana,Arial;color:#000;');
                docprint.document.write('font-family:Verdana, Geneva, sans-serif; font-size:20px;}');
                docprint.document.write('a{color:#000;text-decoration:none;} ');
                docprint.document.write('.stickertable{ border-collapse: collapse;margin-bottom: 20px; width:540px;height:540px} ');
                docprint.document.write('.printarea{ font-size: 30px;text-align: center;}');

                docprint.document.write('.addpad{ padding: 10px; }');
                docprint.document.write('@media all { .page-break { display: block;vertical-align: middle;margin-top:20px; }}');
                docprint.document.write('@media print { .page-break { display: block; page-break-before: always; }}  @page { size: auto;  margin: 0mm; }');        
                docprint.document.write('.stickertable td{ padding-bottom:10px;  }');
                docprint.document.write('@page { size: 101.6mm 152.4mm;}</style>');
                docprint.document.write('</head><body onLoad="self.print()"><center>');
                docprint.document.write(content_vlue);
                docprint.document.write('</center></body></html>');
                docprint.document.close();
            }
            else
            {
                this.$fire({
                  text:"Please Select Check Box",
                  type: "warning",
                  timer: 30000
                });
            }
            
        },

        setStickerHTMl(e,value){
                this.zoneArr=[];
                this.checkedData=true;
                this.selected_zone_id = value.zone_id;
                console.log("Value",value);
                const obj = {
                zone_id:`${value.zone_id}`,
                zone_title:value.zone_title,
                 }
          this.zoneArr.push(obj);
          console.log("Titlwwwwww",this.zoneArr);

        },

    },
}
</script>

<style>

</style>